


import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const token = localStorage.getItem("Token");
  return token ? <Outlet /> : <Navigate to="/Login" replace />;
};

export default ProtectedRoute;
